import { Input } from 'antd';
import React from 'react';
import { Button, Space } from 'antd';
import Highlighter from 'react-highlight-words';
import { FilterDropdownProps } from 'antd/lib/table/interface';
import { SearchOutlined } from '@ant-design/icons';

interface ColumnSearchProps {
  dataIndex: string;
  searchInput: any;
  searchText: string;
  searchedColumn: string; // Add this line
  handleSearch: (selectedKeys: string[], confirm: () => void) => void;
  handleReset: (clearFilters: () => void) => void;
  i18n: any;
}

export const getColumnSearchProps = ({
  dataIndex,
  searchInput,
  searchText,
  handleSearch,
  handleReset,
  i18n,
}: ColumnSearchProps) => ({
  filterDropdown: ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
  }: FilterDropdownProps) => (
    <div style={{ padding: 8 }}>
      <Input
        ref={searchInput}
        placeholder={i18n.t('search')}
        value={selectedKeys[0]}
        onChange={(e) =>
          setSelectedKeys(e.target.value ? [e.target.value] : [])
        }
        onPressEnter={() =>
          handleSearch(selectedKeys as string[], confirm)
        }
        style={{ marginBottom: 8, display: 'block' }}
      />
      <Space>
        <Button
          type="primary"
          onClick={() =>
            handleSearch(selectedKeys as string[], confirm)
          }
          size="small"
          style={{ width: 90 }}
        >
          {i18n.t('search')}
        </Button>
        <Button
          size="small"
          style={{ width: 90 }}
          onClick={() => {
            confirm({ closeDropdown: false });
          }}
        >
          {i18n.t('filter')}
        </Button>
        <Button
          type="link"
          onClick={() => clearFilters && handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          {i18n.t('reset')}
        </Button>

        <Button
          type="link"
          size="small"
          style={{ color: 'red' }}
          onClick={() => {
            confirm();
          }}
        >
          {i18n.t('close')}
        </Button>
      </Space>
    </div>
  ),
  filterIcon: (filtered: boolean) => (
    <SearchOutlined
      style={{ color: filtered ? '#1890ff' : undefined }}
    />
  ),
  onFilter: (value: string, record: any) => {
    let recordValue = '';
    if (dataIndex === 'creator' && record[dataIndex]) {
      recordValue = record[dataIndex].name;
    } else {
      recordValue = String(record[dataIndex]);
    }

    if (recordValue == null) {
      return false;
    }

    return recordValue.toLowerCase().includes(value.toLowerCase());
  },

  onFilterDropdownOpenChange: (visible: boolean) => {
    if (visible) {
      setTimeout(() => searchInput.current?.select(), 100);
    }
  },
  render: (text: any) =>
    searchText && dataIndex === 'name' ? (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text ? text.toString() : ''}
      />
    ) : (
      text
    ),
});
